(() => {
  if (customElements.get('serenova-image-gallery')) return;

  class SerenovaImageGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.dialog = this.querySelector('.about-gallery__dialog');
      this.fullImage = this.querySelector('.about-gallery__full-image');
      this.caption = this.querySelector('.about-gallery__caption');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.initialized = true;

      this.addEventListener('click', (event) => {
        const link = event.target.closest('.about-gallery__expand');
        if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
          event.preventDefault();
          this.openImage(link);
        }
      });
      this.querySelector('.about-gallery__close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.restorePage());
    }

    openImage(link) {
      const thumbnail = link.querySelector('img');
      this.trigger = link;
      this.fullImage.src = link.href;
      this.fullImage.alt = thumbnail.alt;
      this.fullImage.width = thumbnail.naturalWidth || thumbnail.width;
      this.fullImage.height = thumbnail.naturalHeight || thumbnail.height;
      this.caption.textContent = thumbnail.alt;
      this.dialog.showModal();
    }

    restorePage() {
      // A queued close event from the previous image may arrive after reopening.
      if (this.dialog?.open) return;
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restorePage();
    }
  }

  customElements.define('serenova-image-gallery', SerenovaImageGallery);
})();
